import { render } from "./approval-add-bar.vue?vue&type=template&id=6c2c823a"
import script from "./approval-add-bar.vue?vue&type=script&lang=js"
export * from "./approval-add-bar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__